export default function stringContainsAnySubstr(substrings = [], str) {
  return substrings.some((v) => str.includes(v))
}
